import React from 'react';
import SVGTile from '@99designs/apps/spa/pages/create/components/SVGTile';
import { Box, SmallSectionHeading } from '@99designs/emu';
import { Desktop } from '@99designs/frontend-components/components/Desktop';
import { Mobile } from '@99designs/frontend-components/components/Mobile';
import { IconRight1 } from '@99designs/icons';

export default function BriefEntryAction({ svg, title }: { svg: string; title: string }) {
    return (
        <>
            <Desktop>
                <SVGTile narrowText largeText svg={svg} title={title} />
            </Desktop>
            <Mobile>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    paddingY="1bu"
                    paddingX="2bu"
                >
                    <SmallSectionHeading>{title}</SmallSectionHeading>
                    <IconRight1 fontSize={24} />
                </Box>
            </Mobile>
        </>
    );
}
